(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('FileContentDeleteController',FileContentDeleteController);

    FileContentDeleteController.$inject = ['$uibModalInstance', 'entity', 'FileContent'];

    function FileContentDeleteController($uibModalInstance, entity, FileContent) {
        var vm = this;

        vm.fileContent = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            FileContent.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
